import {Utils, TLPointerEventHandler} from '@tldraw/core'
import {SessionType} from '@modules/whiteboard'
import {BaseTool} from '@modules/whiteboard/tools/BaseTool'
import {action} from '@api'
import {computed} from 'mobx'

export class DrawTool extends BaseTool {
  type: string = 'draw' as const

  @computed get tool() {
    const {type, app: {shapeUtils: {draw, highlighter}}} = this
    switch (type) {
      case 'highlighter':
        return highlighter

      default:
        return draw
    }
  }

  /* ----------------- Event Handlers ----------------- */

  @action onPointerDown: TLPointerEventHandler = (info) => {
    const {
        app: {
          currentPoint, shapeUtils: {draw},
          ui: {currentPageId, currentStyle}, patchCreate
        }, nextChildIndex: childIndex, tool
      } = this,
      id = Utils.uniqueId(),
      newShape = tool.create({
        id,
        parentId: currentPageId,
        childIndex,
        point: [...currentPoint, info.pressure || 0.5],
        style: {...currentStyle}
      })

    patchCreate([newShape])

    this.tools.startSession(this.type as SessionType, id)

    this.status = 'creating'
  }

  @action onPointerMove: TLPointerEventHandler = () => {
    if (this.status === 'creating') {
      this.updateSession()
    }
  }

  @action onPointerUp: TLPointerEventHandler = () => {
    if (this.status === 'creating') {
      this.completeSession()
    }

    this.status = 'idle'
  }
}



// WEBPACK FOOTER //
// ./src/modules/whiteboard/tools/DrawTool/DrawTool.ts